export default "__VITE_ASSET__DM$UcCIk__"